<div class="my-4 mx-5">
    <router-outlet></router-outlet>
</div>
